import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpBackEndService } from '../services/http-back-end-service.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorGuard  {
    private backendService = inject(HttpBackEndService);
    private router = inject(Router);

    canActivate(): boolean {    
      if (this.backendService.isErrorRedirected()) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
    }

}
